import { headerWithUnitTemplate } from "@/utils/column_mapping/HeaderTemplates";

function roundN(num, n) {
  if (num % 1 != 0) {
    return parseFloat(
      Math.round(num * Math.pow(10, n)) / Math.pow(10, n)
    ).toFixed(n);
  }
  return num;
}

const InputVoltages = {
  i120Vac: 9,
  i200Vac: 10,
  i230Vac: 11,
  i240Vac: 12,
  i277Vac: 13,
  i347Vac: 14,
  i480Vac: 15,
  i120_277Vac: 16,
  i347_480Vac: 17,
  i120_230Vac: 18,
};

// Todo this should be decided in the backend
function getInputVoltage(inputVoltages) {
  let label = [],
    labels = [],
    has120Vac = false,
    has230Vac = false,
    has277Vac = false,
    has347Vac = false,
    has480Vac = false,
    has120_230Vac = false,
    has120_277Vac = false,
    has347_480Vac = false;

  inputVoltages.map((inputVoltage) => {
    labels[inputVoltage.id] = inputVoltage.name;

    switch (inputVoltage.id) {
      case InputVoltages.i120Vac:
        has120Vac = true;
        break;
      case InputVoltages.i230Vac:
        has230Vac = true;
        break;
      case InputVoltages.i277Vac:
        has277Vac = true;
        break;
      case InputVoltages.i347Vac:
        has347Vac = true;
        break;
      case InputVoltages.i480Vac:
        has480Vac = true;
        break;
      case InputVoltages.i120_230Vac:
        has120_230Vac = true;
        break;
      case InputVoltages.i120_277Vac:
        has120_277Vac = true;
        break;
      case InputVoltages.i347_480Vac:
        has347_480Vac = true;
        break;
    }
  });

  if (has347_480Vac && (has347Vac || has480Vac)) {
    return labels[InputVoltages.i347_480Vac];
  }

  if (has120_277Vac && (has120Vac || has277Vac)) {
    return labels[InputVoltages.i120_277Vac];
  }

  if (has120_230Vac && (has120Vac || has230Vac)) {
    return labels[InputVoltages.i120_230Vac];
  }

  for (let l of labels) {
    if (l !== undefined) {
      label.push(l);
    }
  }

  return label.join(",");
}

const nameHeader = {
  headerName: "Product Name",
  field: "name",
  sortable: true,
  hide: false,
  width: 300,
};

const shortNameHeader = {
  headerName: "Product Name",
  field: "name",
  sortable: true,
  hide: false,
  width: 150,
};

const marketingNameHeader = {
  headerName: "Product description",
  field: "marketingName",
  sortable: true,
  hide: false,
  rowDrag: false,
  width: 300,
};

const nc12Header = {
  headerName: "12nc",
  field: "nc12",
  sortable: true,
  hide: false,
  width: 115,
};

const dimmingTypesHeader = {
  headerName: "Dimming",
  field: "dimmingTypes",
  sortable: true,
  hide: false,
  width: 100,
  valueFormatter: (params) => {
    return params.value.map((item) => item.name).join(", ");
  },
};

const minDimPercentageHeader = {
  headerName: "Min. Dim.",
  field: "minDimPercentage",
  sortable: true,
  hide: false,
  width: 80,
  headerComponentParams: {
    template: headerWithUnitTemplate("%"),
  },
};

const inputVoltagesHeader = {
  headerName: "Input voltage",
  field: "inputVoltages",
  sortable: true,
  hide: false,
  width: 100,
  valueFormatter: (params) => {
    return getInputVoltage(params.value);
  },
  headerComponentParams: {
    template: headerWithUnitTemplate("V"),
  },
};

const mountingHeader = {
  headerName: "Mounting",
  field: "mountingTypes",
  sortable: true,
  hide: false,
  width: 80,
  valueFormatter: (params) => {
    return params.value.map((item) => item.name).join(", ");
  },
};

const pOutMax = {
  headerName: "Pout max",
  field: "opMax",
  sortable: true,
  hide: false,
  width: 80,
  valueFormatter: (params) => {
    return roundN(params.value, 1);
  },
  headerComponentParams: {
    template: headerWithUnitTemplate("W"),
  },
};

const iOutMin = {
  headerName: "Iout min",
  field: "ocMin",
  sortable: true,
  hide: false,
  width: 80,
  valueFormatter: (params) => {
    return Math.round(params.value * 1000);
  },
  headerComponentParams: {
    template: headerWithUnitTemplate("mA"),
  },
};

const iOutMax = {
  headerName: "Iout max",
  field: "ocMax",
  sortable: true,
  hide: false,
  width: 80,
  valueFormatter: (params) => {
    if (params.value === null) return null;
    return Math.round(params.value * 1000);
  },
  headerComponentParams: {
    template: headerWithUnitTemplate("mA"),
  },
};

const iInMax = {
  headerName: "Iin max",
  field: "ibodineMaxIn",
  sortable: true,
  hide: false,
  width: 80,
  valueFormatter: (params) => {
    if (params.value === 0 || params.value === null) return "";
    return params.value;
  },
  headerComponentParams: {
    template: headerWithUnitTemplate("mA"),
  },
};

const vOutMin = {
  headerName: "Vout min",
  field: "ovMin",
  sortable: true,
  hide: false,
  width: 80,
  valueFormatter: (params) => {
    return roundN(params.value, 1);
  },
  headerComponentParams: {
    template: headerWithUnitTemplate("V"),
  },
};
const vOutMax = {
  headerName: "Vout max",
  field: "ovMax",
  sortable: true,
  hide: false,
  width: 80,
  valueFormatter: (params) => {
    return roundN(params.value, 1);
  },
  headerComponentParams: {
    template: headerWithUnitTemplate("V"),
  },
};

const isolationHeader = {
  headerName: "Isolation",
  field: "isolationClass.name",
  sortable: true,
  hide: false,
  width: 80,
};

const effAtFullLoadHeader = {
  headerName: "Eff. max",
  field: "eff",
  sortable: true,
  hide: false,
  width: 100,
  valueFormatter: (params) => {
    return Math.round(params.value * 2) / 2;
  },
  headerComponentParams: {
    template: headerWithUnitTemplate("%", true),
  },
  headerTooltip: "Efficiency at full load",
};

const effAtOperatingPoint230 = {
  headerName: "Eff. at 230Vac",
  field: "driverCalculationResult.mainsEfficiency",
  sortable: true,
  hide: false,
  width: 130,
  valueFormatter: (params) => {
    return params.value[230]
      ? (Math.round(roundN(params.value[230], 1) * 2) / 2).toString()
      : "-";
  },
  headerComponentParams: {
    template: headerWithUnitTemplate("%", true),
  },
  headerTooltip: "Efficiency at operating point at indicated mains",
};

const effAtOperatingPoint120 = {
  headerName: "Eff. at 120Vac",
  field: "driverCalculationResult.mainsEfficiency",
  sortable: true,
  hide: false,
  width: 130,
  valueFormatter: (params) => {
    return params.value[120]
      ? (Math.round(roundN(params.value[120], 1) * 2) / 2).toString()
      : "-";
  },
  headerComponentParams: {
    template: headerWithUnitTemplate("%", true),
  },
  headerTooltip: "Efficiency at operating point at indicated mains",
};

const effAtOperatingPoint277 = {
  headerName: "Eff. at 277Vac",
  field: "driverCalculationResult.mainsEfficiency",
  sortable: true,
  hide: false,
  width: 130,
  valueFormatter: (params) => {
    return params.value[277]
      ? (Math.round(roundN(params.value[277], 1) * 2) / 2).toString()
      : "-";
  },
  headerComponentParams: {
    template: headerWithUnitTemplate("%", true),
  },
  headerTooltip: "Efficiency at operating point at indicated mains",
};

const effAtOperatingPoint347 = {
  headerName: "Eff. at 347Vac",
  field: "driverCalculationResult.mainsEfficiency",
  sortable: true,
  hide: false,
  width: 130,
  valueFormatter: (params) => {
    return params.value[347]
      ? (Math.round(roundN(params.value[347], 1) * 2) / 2).toString()
      : "-";
  },
  headerComponentParams: {
    template: headerWithUnitTemplate("%", true),
  },
  headerTooltip: "Efficiency at operating point at indicated mains",
};

const effAtOperatingPoint480 = {
  headerName: "Eff. at 480Vac",
  field: "driverCalculationResult.mainsEfficiency",
  sortable: true,
  hide: false,
  width: 130,
  valueFormatter: (params) => {
    return params.value[480]
      ? (Math.round(roundN(params.value[480], 1) * 2) / 2).toString()
      : "-";
  },
  headerComponentParams: {
    template: headerWithUnitTemplate("%", true),
  },
  headerTooltip: "Efficiency at operating point at indicated mains",
};

const class2Header = {
  headerName: "Class 2",
  field: "classification",
  sortable: true,
  hide: false,
  width: 70,
  valueFormatter: (params) => {
    if (params.value != null) {
      return params.value.name === "Class 2";
    }
    return false;
  },
};

const featuresHeader = {
  headerName: "Features",
  field: "features",
  sortable: true,
  hide: false,
  width: 80,
  valueFormatter: (params) => {
    return params.value.map((item) => item.name).join(", ");
  },
};

const certificationsHeader = {
  headerName: "Certifications",
  field: "certifications",
  sortable: true,
  hide: false,
  width: 80,
  valueFormatter: (params) => {
    return params.value.map((item) => item.name).join(", ");
  },
};

const urlULHeader = {
  headerName: "UL",
  field: "ulUrl",
  sortable: true,
  hide: false,
  cellRenderer: (params) => {
    return params.value !== ""
      ? `<a href="${params.value}" target="_blank">View</a>`
      : "-";
  },
  width: 60,
  headerComponentParams: {
    template: headerWithUnitTemplate("url"),
  },
};

const urlCSAHeader = {
  headerName: "CSA",
  field: "csaUrl",
  sortable: true,
  hide: false,
  cellRenderer: (params) => {
    return params.value !== ""
      ? `<a href="${params.value}" target="_blank">View</a>`
      : "-";
  },
  width: 65,
  headerComponentParams: {
    template: headerWithUnitTemplate("url"),
  },
};

const urlInertekHeader = {
  headerName: "Inertek",
  field: "inertekUrl",
  sortable: true,
  hide: false,
  cellRenderer: (params) => {
    return params.value !== ""
      ? `<a href="${params.value}" target="_blank">View</a>`
      : "-";
  },
  width: 80,
  headerComponentParams: {
    template: headerWithUnitTemplate("url"),
  },
};

const url3DHeader = {
  headerName: "3D",
  field: "file3dUrl",
  sortable: true,
  hide: false,
  cellRenderer: (params) => {
    return params.value !== ""
      ? `<a href="${params.value}" target="_blank">View</a>`
      : "-";
  },
  width: 60,
  headerComponentParams: {
    template: headerWithUnitTemplate("url"),
  },
};

const setOutPutCurrent = {
  headerName: "Set output current",
  field: "driverConfigurability",
  sortable: true,
  hide: false,
  width: 80,
  valueFormatter: (params) => {
    return params.value.length > 0 ? params.value.join(", ") : "-";
  },
};

const heightHeader = {
  headerName: "Height",
  field: "housing.height",
  sortable: true,
  hide: false,
  width: 70,
  valueFormatter: (params) => {
    return roundN(params.value, 1);
  },
  headerComponentParams: {
    template: headerWithUnitTemplate("mm"),
  },
};

const heightHeaderInch = {
  headerName: "Height",
  field: "housing.height",
  sortable: true,
  hide: false,
  width: 70,
  valueFormatter: (params) => {
    return roundN(params.value, 2);
  },
  headerComponentParams: {
    template: headerWithUnitTemplate("inch"),
  },
};

const widthHeader = {
  headerName: "Width",
  field: "housing.width",
  sortable: true,
  hide: false,
  width: 70,
  valueFormatter: (params) => {
    return roundN(params.value, 1);
  },
  headerComponentParams: {
    template: headerWithUnitTemplate("mm"),
  },
};

const widthHeaderInch = {
  headerName: "Width",
  field: "housing.width",
  sortable: true,
  hide: false,
  width: 70,
  valueFormatter: (params) => {
    return roundN(params.value, 2);
  },
  headerComponentParams: {
    template: headerWithUnitTemplate("inch"),
  },
};
const familyHeader = {
  headerName: "Application",
  field: "familyLevelOne",
  sortable: true,
  hide: false,
  width: 100,
};

const dataSheetHeader = {
  headerName: "Datasheet",
  field: "datasheetUrl",
  sortable: true,
  hide: false,
  cellRenderer: (params) => {
    return params.value !== ""
      ? `<a href="${params.value}" target="_blank">View</a>`
      : "-";
  },
  width: 90,
};
const lengthHeader = {
  headerName: "Length",
  field: "housing.length",
  sortable: true,
  hide: false,
  width: 70,
  valueFormatter: (params) => {
    return roundN(params.value, 1);
  },
  headerComponentParams: {
    template: headerWithUnitTemplate("mm"),
  },
};
const lengthHeaderInch = {
  headerName: "Length",
  field: "housing.length",
  sortable: true,
  hide: false,
  width: 70,
  valueFormatter: (params) => {
    return roundN(params.value, 2);
  },
  headerComponentParams: {
    template: headerWithUnitTemplate("inch"),
  },
};
export {
  marketingNameHeader,
  nameHeader,
  shortNameHeader,
  familyHeader,
  dataSheetHeader,
  pOutMax,
  iOutMax,
  iOutMin,
  iInMax,
  vOutMax,
  vOutMin,
  setOutPutCurrent,
  dimmingTypesHeader,
  minDimPercentageHeader,
  inputVoltagesHeader,
  effAtFullLoadHeader,
  effAtOperatingPoint230,
  effAtOperatingPoint120,
  effAtOperatingPoint277,
  effAtOperatingPoint347,
  effAtOperatingPoint480,
  class2Header,
  featuresHeader,
  certificationsHeader,
  urlULHeader,
  urlCSAHeader,
  urlInertekHeader,
  url3DHeader,
  isolationHeader,
  mountingHeader,
  lengthHeader,
  lengthHeaderInch,
  widthHeader,
  widthHeaderInch,
  heightHeader,
  heightHeaderInch,
  nc12Header,
  getInputVoltage,
};
